module.exports = __webpack_public_path__ + "static/media/logo_large.f2d35ebf.png";